import { Pipe, PipeTransform, inject } from '@angular/core';
import { AccountPermission } from '@moxi.gmbh/moxi-typescriptmodels';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationFacade } from '@shared/data';
import { teamRolesInfo } from '@shared/models';

interface TeamRole {
  role: string;
  teamName: string;
}

@Pipe({
  name: 'userTeamRoleName',
  standalone: true
})
export class UserTeamRolesPipe implements PipeTransform {
  private readonly account = inject(ApplicationFacade).selectedAccount();
  private readonly translateService = inject(TranslateService);

  transform(
    value: AccountPermission | AccountPermission[],
    teamId?: string
  ): TeamRole[] {
    const account =
      value instanceof Array
        ? value?.find(a => a.accountId === this.account.accountId)
        : value;

    return account?.teamPermissions
      .filter(teamPermission =>
        teamId ? teamPermission.teamId === teamId : true
      )
      .flatMap(teamPermission =>
        teamPermission?.roles.map(role => ({
          role: this.translateService.instant(
            teamRolesInfo.find(r => r.id === role)?.name
          ),
          teamName: this.account.teams?.find(
            team => team.teamId === teamPermission.teamId
          )?.info?.teamName
        }))
      );
  }
}
